import { BusinessRegistrationUI } from '../../ui/business/types';
import type { BusinessRegistrationModel } from '../../data-layer/business/types';

export const toBusinessRegistrationPersistenceModel = (
    model: BusinessRegistrationUI,
): BusinessRegistrationModel => ({
    ...model,
    telegramUrl: model.telegramUrl || undefined,
});
